import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogLookupPermissionsComponent } from 'src/app/+home/+my-libraries/+sites/document-library/shared/dialog-lookup-permissions/dialog-lookup-permissions.component';
import { DialogLookupUsersGroupsComponent } from 'src/app/+home/shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import { User } from 'src/shared/models/user.class';

@Component({
  selector: 'see-permissions-kanban',
  templateUrl: './see-permissions-kanban.component.html',
  styleUrls: ['./see-permissions-kanban.component.scss']
})
export class SeePermissionsKanbanComponent implements OnInit {
  @Input() public listUsersAndGroups: any[];

  constructor(private matDialog: MatDialog) { }

  ngOnInit() {
  }

  ngOnChanges(){
    
  }

  onOpenLookup() {
    const dialogRef = this.matDialog.open(DialogLookupPermissionsComponent, {
      width: '60%',
      height: '45%',
      data: { onlyUsers: true, hidePermissions: true }
    });

    dialogRef.afterClosed().subscribe((result: any[]) => {
      if (result) {
        result.forEach((user) => {
          user = {
            id: user.nodeType === 'cm:person' ? user.properties['cm:owner'].id : user.id,
            displayName: user.nodeType === 'cm:person' ? user.properties['cm:owner'].displayName : user.name,
            uType: user.nodeType
          };
          
          let el = this.listUsersAndGroups.find((el) => el.id === user.id);

          if (!el) {
            this.listUsersAndGroups.push(user);
          }
        });
      }
    });
    this.ngOnInit()
  }
}


